import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "../../components/generalComponents/Table";
import { fetchOrderHistory } from "../../services/orderHistory/actions";

function OrderHistory(props) {
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    await props.fetchOrderHistory(props.userId);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    // disable fetchAll dependency warning
    // eslint-disable-next-line
  }, []);

  const orderHistoryColumnsTable = [
    { name: "Afleverdatum", dataName: "delivery_date" },
    { name: "Leverancier", dataName: "supplier" },
    { name: "Status", dataName: "order_status" },
    { name: "", dataName: "arrow_button_order" },
  ];

  return (
    <>
      {!loading && (
        <Table
          data={props.orderHistory}
          columnsMapping={orderHistoryColumnsTable}
          screenType="orderHistory"
        />
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    orderHistory: state.orderHistory.orderHistory,
    userId: state.login.data.user_id,
  };
}

export default connect(mapStateToProps, {
  fetchOrderHistory,
})(OrderHistory);
